//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Button} from '@material-ui/core';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import {colors} from '../../../../../assets/styles/colors';
import {Add} from '@material-ui/icons';
import {useStorePromotions} from '../../../../marketing/promotions/utils';

const useStyles = makeStyles(theme => ({
  addBannerButton: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: colors.grey500,
    border: `2px dashed ${colors.grey500}`,
    borderRadius: '.75rem',
    paddingBlock: '.85rem',
  },
  bannerList: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      borderBottom: `1px solid ${colors.grey300}`,
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
  caption: {
    color: colors.grey500,
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '1rem',
    display: 'block',
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function Promotion(props: Props) {
  const {sectionEnabled} = props;

  const classes = useStyles();
  const promotions = useStorePromotions();
  const emptyContent = !(
    promotions.length > 0 && promotions.some(p => p.enabled)
  );

  return (
    <SwitchableSection
      title="Promociones/Ofertas"
      subtitle="Crea de ofertas o promociones relevantes para tus clientes"
      id={HOME_PAGE_SECTION_NAMES.STORE_PROMOTIONS}
      classes={{
        root: (emptyContent || !sectionEnabled) && classes.disabledRoot,
      }}
    >
      <span className={classes.caption}>
        Hay {promotions.length} promociones activas
      </span>
      <Button
        fullWidth
        className={classes.addBannerButton}
        component={Link}
        to="/marketing/promotions"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Add />
        Agregar promoción
      </Button>
    </SwitchableSection>
  );
}
